import React from "react";
import { TabsTrigger } from "@/components/ui/tabs";

/**
 * Semantic color-tokens for module tabs. Each token → gradient bg + active state.
 *
 * Use like:  <ColorTab value="approvals" tone="green" testid="acc-tab-approvals" icon={CheckCircle2}>Approvals</ColorTab>
 */
export const TAB_TONES = {
  // GREEN — success / approvals / money-in
  green:  "text-emerald-800 bg-emerald-50 hover:bg-emerald-100 border-emerald-200 " +
          "data-[state=active]:bg-emerald-600 data-[state=active]:text-white data-[state=active]:border-emerald-700",
  // BLUE — reports / analytics / dashboards
  blue:   "text-blue-800 bg-blue-50 hover:bg-blue-100 border-blue-200 " +
          "data-[state=active]:bg-blue-600 data-[state=active]:text-white data-[state=active]:border-blue-700",
  // RED — issues / QC fail / overdue
  red:    "text-red-800 bg-red-50 hover:bg-red-100 border-red-200 " +
          "data-[state=active]:bg-red-600 data-[state=active]:text-white data-[state=active]:border-red-700",
  // AMBER — money-out / warnings / holds
  amber:  "text-amber-800 bg-amber-50 hover:bg-amber-100 border-amber-200 " +
          "data-[state=active]:bg-amber-500 data-[state=active]:text-white data-[state=active]:border-amber-600",
  // PURPLE — documents / vouchers / compliance
  purple: "text-purple-800 bg-purple-50 hover:bg-purple-100 border-purple-200 " +
          "data-[state=active]:bg-purple-600 data-[state=active]:text-white data-[state=active]:border-purple-700",
  // ORANGE — brand-anchor / primary flows
  orange: "text-[#7B341E] bg-[#FEEBC8] hover:bg-[#F6AD55]/50 border-[#F6AD55] " +
          "data-[state=active]:bg-[#C05621] data-[state=active]:text-white data-[state=active]:border-[#9C4221]",
  // SLATE — neutral / advanced
  slate:  "text-slate-700 bg-slate-100 hover:bg-slate-200 border-slate-300 " +
          "data-[state=active]:bg-slate-800 data-[state=active]:text-white data-[state=active]:border-slate-900",
};

export function ColorTab({ value, tone = "slate", icon: Icon, children, testid, badge }) {
  const cls = TAB_TONES[tone] || TAB_TONES.slate;
  return (
    <TabsTrigger
      value={value}
      data-testid={testid}
      className={`border rounded-md px-3 py-1.5 mx-0.5 my-0.5 font-medium transition-all shadow-sm data-[state=active]:shadow ${cls}`}
    >
      {Icon && <Icon className="w-3.5 h-3.5 mr-1.5" />}
      <span className="whitespace-nowrap">{children}</span>
      {badge > 0 && (
        <span className="ml-1.5 inline-flex items-center justify-center h-4 min-w-[16px] rounded-full bg-red-600 text-white text-[10px] px-1 font-bold shadow">
          {badge}
        </span>
      )}
    </TabsTrigger>
  );
}
